<template>
  <div class="index-container">
    <div class="container-aside">
      <div class="main-menu">
        <img src="../../assets/znAdmin.png" class="zn-admin" />
        <div
          v-for="(item, index) in mainMemu"
          :key="index"
          :class="index == currentMenu ? 'menu-item menu-active' : 'menu-item'"
          @click="changeMainMenu(index)"
        >
          <img
            :src="index == currentMenu ? item.icon2 : item.icon1"
            class="func-icon"
          />
          {{ item.label }}
          <div class="active-icon" v-show="currentMenu == index"></div>
        </div>
      </div>
      <div class="sub-menu">
        <div class="title">
          {{ mainMemu[currentMenu] ? mainMemu[currentMenu].subTitle : '' }}
        </div>
        <div
          v-for="(item, index) in subMenu"
          :key="index"
          :class="currentSub == index ? 'tab-item tab-active' : 'tab-item'"
          @click="changeSubMenu(index)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="contaienr-right">
      <div class="container-header"><layout></layout></div>
      <div :class="`contaienr-main ${isCombo ? 'ocontainer-main' : ''}`">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { getPermissionList, getMenuList } from '@/api/index'
  import { getCompletionUrl } from '@/utils/index'
  export default {
    components: {
      layout: () => import('@/components/mainView/layout/layout'),
    },

    data() {
      return {
        currentMenu: 0,
        currentSub: 0,
        mainMemu: [],
        subMenu: [],
        isCombo: false,
      }
    },
    async created() {
      let mainMemu = JSON.parse(window.sessionStorage.getItem('menuList'))
      if (mainMemu instanceof Array) {
        this.mainMemu = mainMemu
      } else {
        await this.getMenuList()

        const menu = await this.getPemissionList()
        let memuIds = []
        menu.forEach((item) => {
          memuIds.push(item.id)
        })
        memuIds = new Set(memuIds)
        this.mainMemu = this.mainMemu.filter((item) => {
          item.children = item.children.filter((item1) => memuIds.has(item1.id))
          return memuIds.has(item.id)
        })
      }

      window.sessionStorage.setItem('menuList', JSON.stringify(this.mainMemu))
      //   this.mainMemu = menuInfo
      let memuIndex = window.sessionStorage.getItem('menu')
      let subIndex = window.sessionStorage.getItem('subMenu')
      // 处理页面刷新
      if (memuIndex == null && subIndex == null) {
        this.subMenu = this.mainMemu[0].children

        this.$router.replace(this.mainMemu[0].router)
      } else if (memuIndex == null && subIndex != null) {
        this.subMenu = this.mainMemu[0].children
        this.currentMenu = 0
        this.currentSub = subIndex
        this.$router.replace(this.mainMemu[0].children[subIndex].router)
      } else {
        this.currentMenu = memuIndex
        this.currentSub = subIndex
        this.subMenu = this.mainMemu[memuIndex].children
        this.checkCombo(this.mainMemu[memuIndex].children[subIndex].router)
        this.$router.replace(this.mainMemu[memuIndex].children[subIndex].router)
      }
    },
    computed: {
      ...mapState({
        menu: (state) => state.dataView.menu,
      }),
    },
    watch: {
      menu: function (val) {
        this.changeMainMenu(window.sessionStorage.getItem('menu'))
        this.changeSubMenu(window.sessionStorage.getItem('subMenu'))
      },
    },
    methods: {
      async getPemissionList() {
        const res = await getPermissionList()
        return res.data.menuList
      },
      async getMenuList() {
        const res = await getMenuList()
        this.mainMemu = res.data.map((item) => {
          item.icon1 = getCompletionUrl(item.icon1)
          item.icon2 = getCompletionUrl(item.icon2)
          return item
        })
      },
      changeSubMenu(index) {
        this.isCombo = this.currentSub = index
        window.sessionStorage.setItem('subMenu', index)
        window.sessionStorage.removeItem('thirdMenu')
        this.checkCombo(this.subMenu[index].router)
        this.$router.replace(this.subMenu[index].router)
      },
      changeMainMenu(index) {
        this.currentMenu = index
        this.currentSub = 0
        this.subMenu = this.mainMemu[index].children
        window.sessionStorage.setItem('menu', index)
        window.sessionStorage.setItem('subMenu', 0)
        window.sessionStorage.removeItem('thirdMenu')
        this.checkCombo(this.mainMemu[index].router)
        this.$router.replace(this.mainMemu[index].router)
      },
      checkCombo(router) {
        this.isCombo = router == '/combo'
      },
    },
  }
</script>
<style lang="scss" scoped>
  .index-container {
    display: flex;
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    background-color: #f9fafc;
    .func-icon {
      margin-right: 8px;
      width: 18px;
      height: 18px;
    }
  }
  .contaienr-right {
    display: flex;
    flex-direction: column;
    width: calc(100% - 240px);
    height: 100%;
  }
  .container-aside {
    display: flex;
    width: 240px;
    background-color: #30384f;
    border-right: 1px solid #f1f1f3;
    box-sizing: border-box;
    .main-menu {
      width: 120px;
      .logo {
        height: 64px;
      }
      .menu-item {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-top: 8px;
        width: 100%;
        height: 52px;
        font-size: 16px;
        color: #949aad;
        cursor: pointer;
      }
      .menu-active {
        color: #fff;
        background: linear-gradient(90deg, #39da9b 0%, #20b9a2 100%);
      }
      .active-icon {
        position: absolute;
        right: 0px;
        top: 50%;
        width: 0;
        height: 0;
        border: 9px solid #f9fafc;
        border-color: transparent #f9fafc transparent transparent;
        transform: translateY(-50%);
      }
    }
    .sub-menu {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 120px;
      background-color: #fff;
      font-size: 14px;

      .title {
        margin: 24px 0 18px 0;
        color: #909399;
      }
      .tab-item {
        width: 88px;
        height: 36px;
        border-radius: 8px;
        color: #303133;
        text-align: center;
        line-height: 36px;
        border-radius: 8px;
        cursor: pointer;
      }
      .tab-active {
        color: #303133;
        font-weight: 600;
        background-color: #eef3fa;
      }
    }
  }
  .container-header {
    padding-right: 26px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 52px;
    background-color: #fff;
  }
  .contaienr-main {
    position: relative;
    padding: 24px 26px 0 26px;
    margin: 24px;
    // width: calc(100% - 240px);
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
    overflow-y: scroll;
  }
  .contaienr-main::-webkit-scrollbar {
    display: none;
  }
  .ocontainer-main {
    margin: 0;
    background-color: #f5f5f5;
  }
  .zn-admin {
    margin: 10px 0 0 10px;
    width: 100px;
    height: 60px;
  }
</style>
